import RestApiModel from "@/api/Model/RestApiModel";

class LloydsRiskCode extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-lloyds-risk-codes';
  }
}

export default LloydsRiskCode;
